import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

let _open = null;

// Fehleingang-Abfrage: Promise mit {reason, forward} oder null (Abbruch)
export function askMisdirect(message) {
  return new Promise((resolve) => (_open ? _open(message, resolve) : resolve(null)));
}

// Führt fn(extra) aus; bei Cross-Owner-Sperre (409) Abfrage + Wiederholung mit Freigabe.
export async function callWithMisdirect(fn) {
  try {
    return await fn({});
  } catch (e) {
    const d = e?.response?.data?.detail;
    if (e?.response?.status !== 409 || d?.code !== "cross_owner") throw e;
    const ans = await askMisdirect(d.message);
    if (!ans) return null;
    return fn({ force_misdirected: true, misdirect_reason: ans.reason, create_forward_order: ans.forward });
  }
}

export function MisdirectPromptHost() {
  const [state, setState] = useState(null);
  const [reason, setReason] = useState("");
  const [forward, setForward] = useState(true);

  useEffect(() => {
    _open = (message, resolve) => { setReason(""); setForward(true); setState({ message, resolve }); };
    return () => { _open = null; };
  }, []);

  const close = (val) => { state?.resolve(val); setState(null); };
  return (
    <Dialog open={!!state} onOpenChange={(v) => !v && close(null)}>
      <DialogContent className="max-w-md" data-testid="misdirect-dialog">
        <DialogHeader>
          <DialogTitle>Fehleingang trotzdem zuordnen?</DialogTitle>
          <DialogDescription>{state?.message}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="text-xs text-slate-600">
            Die Zahlung wird dem Mietverhältnis gutgeschrieben und als „Fehleingang – Weiterleitung nötig“ markiert. Für Sie entsteht eine Aufgabe zum Weiterleiten.
          </div>
          <Textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3}
                    placeholder="Begründung (Pflicht), z. B. Mieter hat versehentlich auf das alte Konto überwiesen"
                    data-testid="misdirect-reason" />
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <Checkbox checked={forward} onCheckedChange={(v) => setForward(!!v)} data-testid="misdirect-forward" />
            SEPA-Weiterleitungsauftrag an das richtige Eigentümerkonto anlegen
          </label>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => close(null)}>Abbrechen</Button>
          <Button disabled={!reason.trim()} onClick={() => close({ reason: reason.trim(), forward })}
                  className="bg-amber-600 hover:bg-amber-700" data-testid="misdirect-confirm">
            Trotzdem zuordnen
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
